import styled from '@emotion/styled'
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material'
import { ReplacementsData } from "api/delek"
import EmptyResults from "common/EmptyResults"
import CorrectIcon from "common/icons/Form/CorrectIcon"
import { formatCurrency } from "common/utils/formatters"

const Styled = {
  TableWrapper: styled.div`
    overflow-y: auto;
    transform: rotateX(180deg);
  `,
  Table: styled(Table)`
    transform: rotateX(180deg);
    .bold {
      font-weight: bold;
    }
  `,
  TableHead: styled(TableHead)`
    background-color: ${(p) => p.theme.colors.paleGrey};
  `,
  TableRow: styled(TableRow)`
    border-bottom: 2px solid rgba(135, 148, 161, 0.1);
  `,
  HeadCell: styled(TableCell)`
    font-size: 18px;
    color: ${(p) => p.theme.colors.marine};
    text-align: center;
    padding: 25px 17px;
  `,
  Cell: styled(TableCell)`
    font-size: 16px;
    color: ${(p) => p.theme.colors.bluishGrey};
    text-align: center;
    padding: 25px 17px;
  `,
  Currency: styled.span`
    color: ${(p) => p.theme.colors.marine};
  `,
  Price: styled.span`
    font-size: 20px;
    color: ${(p) => p.theme.colors.marine};
  `,
}

type ReplacementProps = {
  data: ReplacementsData[]
}

const Replacement = ({ data }: ReplacementProps) => (
  <>
    {data.length > 0 && (
      <Container>
        <Styled.TableWrapper>
          <Styled.Table>
            <Styled.TableHead>
              <TableRow>
                <Styled.HeadCell>ספק</Styled.HeadCell>
                <Styled.HeadCell>מק״ט פריט</Styled.HeadCell>
                <Styled.HeadCell>תיאור</Styled.HeadCell>
                <Styled.HeadCell>תיאור באנגלית</Styled.HeadCell>
                <Styled.HeadCell>תיאור דגם</Styled.HeadCell>
                <Styled.HeadCell>מקורי</Styled.HeadCell>
                <Styled.HeadCell>מק״ט ספק</Styled.HeadCell>
                <Styled.HeadCell>קוד דגם</Styled.HeadCell>
                <Styled.HeadCell>מלאי</Styled.HeadCell>
                <Styled.HeadCell className="bold">
                  מחיר מרבי מומלץ
                </Styled.HeadCell>
              </TableRow>
            </Styled.TableHead>
            <TableBody>
              {data.map((replacement, i) => (
                <Styled.TableRow key={i}>
                  <Styled.Cell>{replacement.provider}</Styled.Cell>
                  <Styled.Cell>{replacement.item}</Styled.Cell>
                  <Styled.Cell>{replacement.name}</Styled.Cell>
                  <Styled.Cell>{replacement.foreignName}</Styled.Cell>
                  <Styled.Cell>{replacement.modelDescription}</Styled.Cell>
                  <Styled.Cell>
                    {replacement.isOriginal == "מקורי" && <CorrectIcon />}
                  </Styled.Cell>
                  <Styled.Cell>{replacement.sku}</Styled.Cell>
                  <Styled.Cell>{replacement.vehicleModel}</Styled.Cell>
                  <Styled.Cell>{replacement.isWithQuantity}</Styled.Cell>
                  <Styled.Cell className="bold">
                    <Styled.Currency>₪</Styled.Currency>
                    <Styled.Price>
                      {formatCurrency(replacement.priceWithTax, 2)}
                    </Styled.Price>
                  </Styled.Cell>
                </Styled.TableRow>
              ))}
            </TableBody>
          </Styled.Table>
        </Styled.TableWrapper>
      </Container>
    )}
    {data.length === 0 && <EmptyResults />}
  </>
)

export default Replacement
